<template>
    <b-card :title="title">
        <b-card-body>
            <b-card-header>
                <b-row>
                    <b-col>
                        <b-form-input
                            type="search"
                            placeholder="Search Locations..."
                            v-model="query"
                        ></b-form-input>
                    </b-col>
                    <b-col cols="3">
                        <b-form-checkbox
                            id="checkbox-1"
                            v-model="filters.is_warehouse"
                            name="checkbox-1"
                            :value="1"
                            :unchecked-value="0"
                        >
                            Is Warehouse?
                        </b-form-checkbox>
                    </b-col>
                    <b-col cols="2">
                        <b-button
                            class="float-right"
                            size="sm"
                            v-if="hasPermissionCreate"
                            variant="primary"
                            :to="`${$route.path}/0`"
                            >Add Location</b-button
                        >
                    </b-col>
                </b-row>
            </b-card-header>
            <p class="mt-3">
                Page: {{ pagination.page }} of {{ pageCount }} Total:
                {{ pagination.total }}
            </p>

            <b-table
                responsive
                :fields="locationFields"
                striped
                hover
                :items="locations"
            >
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        v-if="hasPermissionView"
                        :to="`${$route.path}/${row.item.id}`"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="pagination.page"
                        :total-rows="pagination.total"
                        :per-page="pagination.pageSize"
                        aria-controls="locationTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'locations-ListItems',
    mixins: [permissionsMixins],
    props: ['type', 'title'],

    data() {
        return {
            locationFields: [
                {
                    key: 'id',
                    label: '',
                },
                'name',
                'address1',
                'city',
                {
                    key: 'is_warehouse',
                    label: 'Is Warehouse',
                    formatter: value => {
                        return value ? 'Yes' : 'No'
                    },
                },
            ],
            query: '',
            filters: { is_warehouse: null },
        }
    },

    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),

        'filters.is_warehouse': function () {
            this.doSearch()
        },
    },
    mounted() {
        console.log('locations', this.locations)
        this.doSearch()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        locations() {
            return this.$store.state.locations.locations
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        pagination() {
            return this.$store.state.locations.pagination || {}
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    methods: {
        doSearch() {
            const {
                query,
                pagination: { page },
                filters,
            } = this
            this.$store.dispatch('locations/fetchLocations', {
                query,
                page,
                filters,
            })
        },

        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
    },
}
</script>
<style></style>
